// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"ConveniosGeralGer_containerPrincipal__a+GKc","divConvenios":"ConveniosGeralGer_divConvenios__m2V7i","divTitulo":"ConveniosGeralGer_divTitulo__aGowX"};